import { JsonViewModeContextProvider, ViewTypes } from 'ui/treeView';
import { ExpandModes, ExpansionContextProvider } from 'utils/contexts/expansion';

import { FieldsDisplay } from './FieldsDisplay';
import { FieldsFilterProvider } from './filterProvider';
import { ProfileFieldsHeader } from './ProfileFieldsHeader';

export const ProfileFieldsPage = () => (
  <ExpansionContextProvider
    localKey="profile-fields-expand-mode"
    initialMode={ExpandModes.collapse}
  >
    <JsonViewModeContextProvider identifier="user-fields" defaultMode={ViewTypes.table}>
      <FieldsFilterProvider>
        <ProfileFieldsHeader />
        <FieldsDisplay />
      </FieldsFilterProvider>
    </JsonViewModeContextProvider>
  </ExpansionContextProvider>
);
